import React, { FunctionComponent } from 'react';
import styles from './index.module.less';
import ga from '@Lib/ga'

interface IProps {
  dataSource: any
}

const Article:FunctionComponent<IProps> = ({ dataSource }) => {
  const { id, articleType, link, thumb, tag, title, description, author, time, visits } = dataSource
  return (
    <a className={styles['article']} href={link} target='_blank' onClick={() => {
      ga(['文章', '文章-綜述頁', '資訊-文章點擊'])
    }}>
      <div className={styles['car-item']}>
        <img src={thumb} />
      </div>
      <div className={styles['content']}>
        <h4 className={styles['title']}>
          {!!tag && <i>{tag}</i> }{title}
        </h4>
        <p>{description}</p>
        <div className={styles['time']}>
          { !!author && <span>{author}</span> }
          <span>{time}</span>
          <span>閱讀{visits}</span>
        </div>
      </div>
    </a>
  )
}

export default Article;